export const LOGIN_MODAL_MESSAGE = "Please sign in to continue";
